import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs/index';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { MessageFilterService } from '../message-filter.service';
import { MessageFilterActions } from './message-filter.actions';

@Injectable()
export class MessageFilterEffects {

    constructor(
        private actions$: Actions,
        private messageFilterService: MessageFilterService) {
    }

    getDestinatorByPersonId$ = createEffect(() =>
        this.actions$.pipe(
            ofType(MessageFilterActions.getDestinatorFiltersByPersonId),
            mergeMap(({personId}) =>
                this.messageFilterService.getDestinatorFiltersByPersonId(personId)
                    .pipe(
                        map((destinatorFilters: any) =>
                            MessageFilterActions.getDestinatorFiltersByPersonIdSuccess({destinatorFilters})
                        ),
                        catchError(error =>
                            of(MessageFilterActions.getDestinatorFiltersByPersonIdFail({error}))
                        )
                    )
            )
        )
    );

    updateDestinatorFilter$ = createEffect(() =>
        this.actions$.pipe(
            ofType(MessageFilterActions.updateDestinatorFilters),
            mergeMap(({destinatorFilters, destinatorFilterIds}) =>
                this.messageFilterService.updateDestinatorFilters(destinatorFilters, destinatorFilterIds)
                    .pipe(
                        map((response: any) =>
                            MessageFilterActions.updateDestinatorFiltersSuccess({response})
                        ),
                        catchError(error =>
                            of(MessageFilterActions.getDestinatorFiltersByPersonIdFail({error}))
                        )
                    )
            )
        )
    );
}
